<template>
  <el-dialog width="40%" class="dialog" :title="type == 'add' ? '添加归集仓' : '编辑归集仓'" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
    <el-form ref="ruleForm" label-position="right" :rules="rules" :model="formData" label-width="120px">
      <el-form-item label="归集仓名称" prop="warehouseName">
        <el-input v-model="formData.warehouseName" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="归集仓编码" prop="warehouseNo">
        <el-input :disabled="type == 'edit'" v-model="formData.warehouseNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="是否WMS仓" prop="wmsWarehouse">
        <el-select v-model="formData.wmsWarehouse" placeholder="请选择" clearable style="width: 100%">
          <el-option :label="item.name" :key="item.key" :value="item.value" style="width: 100%" v-for="item in wmsWarehouseOption"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="WMS账仓编码" prop="financeWarehouseNo">
        <el-input v-model="formData.financeWarehouseNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="仓库联系人" prop="contact">
        <el-input v-model="formData.contact" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="仓库联系电话" prop="tel">
        <el-input v-model="formData.tel" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="仓库地址" prop="address">
        <el-input type="textarea" :rows="2" v-model="formData.address" placeholder="请输入" clearable></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getWarehouseByNo, saveWarehouse, updateWarehouse } from '@/api/wareHouse'

export default {
  components: {},
  data() {
    return {
      partnershipType: null, //当前用户所属组织 1 子公司 2 第三方 3 总公司
      dialogFormVisible: false,
      type: 'add', //add 新增模式 edit 编辑模式
      originalTel: undefined, // 存储原始电话号码（加密值）
      formData: {
        warehouseName: undefined,
        warehouseNo: undefined,
        wmsWarehouse: undefined, //1 是 0否
        financeWarehouseNo: undefined,
        contact: undefined,
        tel: undefined,
        address: undefined
      },
      telCode: undefined,//加密字符
      wmsWarehouseOption: [],
      tel: undefined,
      rules: {
        warehouseName: [
          {
            required: true,
            message: '归集仓名称长度为1-20个字符',
            trigger: 'blur',
            pattern: /^.{1,20}$/
          }
        ],
        warehouseNo: [
          {
            required: true,
            message: '归集仓编码为1-20个字母或数字',
            trigger: 'blur',
            pattern: /^[A-Za-z0-9]{1,20}$/
          }
        ],
        wmsWarehouse: [
          {
            required: true,
            message: '请选择是否WMS仓',
            trigger: 'blur'
          }
        ],
        financeWarehouseNo: [
          {
            required: false,
            message: 'WMS账仓编码为1-20个字母或数字',
            trigger: 'blur',
            pattern: /^[A-Za-z0-9]{1,20}$/
          }
        ],
        contact: [
          {
            required: true,
            message: '仓库联系人长度为1-20个字符',
            trigger: 'blur',
            pattern: /^.{1,20}$/
          }
        ],
        tel: [
          {
            required: true,
            message: "仓库联系电话为1-20个数字",
            trigger: "blur",
            pattern: /^[0-9]{1,20}$/
          }
        ],
        address: [
          {
            required: true,
            message: "仓库地址长度为1-50个字符",
            trigger: "blur",
            pattern: /^.{1,50}$/
          }
        ]
      },
      btnLoading: false
    }
  },

  computed: {},
  watch: {
    dialogFormVisible: function(val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields()
      }
    },
    'formData.wmsWarehouse': function(val) {
      if (val === 0) {
        this.rules.financeWarehouseNo[0].required = true
      } else {
        this.rules.financeWarehouseNo[0].required = false
      }
    }
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false
    },

    // 打开弹框
    async openDialog(flag, rowData, wmsWarehouseOption) {
      this.type = flag
      this.wmsWarehouseOption = wmsWarehouseOption
      if (this.type == 'edit') {
        this.getDetail(rowData.warehouseNo)
      }
      this.dialogFormVisible = true
    },
    async getDetail(warehouseNo) {
      let { statusCode, message, data } = await getWarehouseByNo(warehouseNo)
      if (statusCode == 200) {
        this.formData.warehouseNo = data.warehouseNo
        this.formData.warehouseName = data.warehouseName
        this.formData.financeWarehouseNo = data.financeWarehouseNo
        this.formData.wmsWarehouse = data.wmsWarehouse
        this.formData.address = data.address
        this.formData.contact = data.contact
        this.formData.tel = await this.getSourceOrigin(data.desensitizationDtoList[0])
      }
    },
    // 确认提交
    submitBtnFun() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.btnLoading = true
          this.saveFormDataReq()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    //新增or编辑
    async saveFormDataReq() {
      let { statusCode, message } = this.type == 'edit' ? await updateWarehouse(this.formData) : await saveWarehouse(this.formData)
      if (statusCode == 200) {
        this.btnLoading = false
        this.$message.success(this.type == 'edit' ? '编辑成功' : '新增成功')
        this.$emit('opera-success')
        this.dialogFormVisible = false
      } else {
        this.$message.error(message)
      }
      this.btnLoading = false
    },

    // 表单重置
    resetFormStatus() {
      this.$refs.ruleForm.resetFields()
    },

    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/addWarehouseDialog.vue